/**
 * Created by Ivan on 28.01.2026
 */

class MissionWindowController extends ScriptComponent {
    onCreate() {
        this.mission = this.options.mission;
        this.closeWindowCallback = this.options.closeWindowCallback;
        this.bundleName = this.options.bundleName || "mission_window";
    }

    onAttach() {
        this.logWindowOpen();
        this.playOpenSound();
    }

    logWindowOpen() {
        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW);
        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW_DAU, { once: true });
    }

    playOpenSound() {
        let openEffect;
        if (this.options.openSound) {
            openEffect = { bundle: this.options.openSound.bundleName, sound: this.options.openSound.key };
        } else if (bundles.main.urls.open_window_effect) {
            openEffect = { bundle: "main", sound: "open_window_effect" };
        }
        if (openEffect) {
            ComponentMap.attach(this.node, new EffectsComponent({ map: { "ui.window.open": openEffect } }));
        }
        cleverapps.effects.fire("ui.window.open", this.node);
    }

    getMission() {
        return this.mission;
    }

    getOptions() {
        return this.options;
    }

    isRunning() {
        return this.mission.isRunning();
    }

    getTimeLeft() {
        return this.mission.getTimeLeft();
    }

    getBundleName() {
        return this.bundleName;
    }

    onShow() {
        this.mission.runningCompetition.table.showUp();
    }

    onClose() {
        this.mission.runningCompetition.updateShownPlace();
        this.mission.updateMissionIcon();
    }

    onDestroy() {
    }
}
